<template>
  <div>
    <v-card class="ma-4" id="head_height">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-cast-education</v-icon>보안 교육 현황
        </v-toolbar-title>
      </v-toolbar>
    </v-card>


    <v-card class="ma-4" v-resize="onResize">
      <v-data-table
        :headers="headers"
        :items="Records"
        :items-per-page="15"
        :height="ChangableHeight"
        fixed-header
      >
        <template v-slot:item.cEduDate="{ item }">
          {{item.cEduDate.substring(0,10)}}
        </template>
        <template v-slot:item.cReEduDate="{ item }">
          {{CalcReEduDate(item.cEduDate)}}
          <!-- item.cEduDate.substring(0,10) -->
        </template>
        <template v-slot:item.cAgree="{ item }">
          <v-chip v-if="item.cCreateUserId != ''" label small color="blue lighten-1" class="white--text pa-2"><v-icon small>mdi-checkbox-blank-circle-outline</v-icon></v-chip>
          <v-chip v-else label small color="red lighten-1" class="white--text pa-2"><v-icon small>mdi-close</v-icon></v-chip>
        </template>
        <template v-slot:item.ShowPledge="{ item }">
          <v-icon @click="ShowDialog(item)" color="black">search</v-icon>
        </template>
        <template v-slot:no-data>
          <div class="black--text">조회 결과가 없습니다.</div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import Util from "../Util.js";

export default {
  components: {
  },
  data: () => ({
    ChangableHeight : "",
    headers: [
      { text: 'No', value: 'sNum',width:"20"},
      { text: '교육 이수자', value: 'cCustomNm',align: "center"},
      { text: '교육 이수 일자', value: 'cEduDate',align: "center"},
      { text: '만료 일자', value: 'cReEduDate',align: "center"},
      { text: '교육여부', value: 'cAgree',align: "center"},
      // { text: '방문증 수령일자', value: 'cAlwayDate', align: 'center'},
      // { text: '방문증 No', value: 'cAlwayNum',align: 'center'},
      // { text: '상시출입자', value: 'cAlwayPerson',align: 'center'},
    ],
    Records : [],
  }),
  computed: {
    ...mapState(["CustomInfo"]),
  },

  created() {
    this.GetSecurityEduLog();
  },

  mounted() {
  },

  methods : {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },

    GetSecurityEduLog(){       
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "GetSecurityEduLog", posData , {
            headers: {
             "Authorization": this.CustomInfo.Token
            }
          })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length == 0) {
              this.cNoMsg = ""
              setTimeout(() => {
                this.cNoMsg = "보안 교육 이수 내역이 없습니다."
              }, 300);
            }

            for (let i = 0; i < res.data.Result.length;i ++){
              res.data.Result[i].sNum = i + 1
            }

            this.Records = res.data.Result
          } else {
            EventBus.$emit("onShowMsg",true, res.data.Msg);
          }
        })
        .catch(err =>{
          EventBus.$emit("onShowMsg",true, err);
        })
    },

    CalcReEduDate(cTestDate) {
      var date = new Date(cTestDate.substring(0,10));
      var date1 = new Date(date.setMonth(date.getMonth()+6))
      var date2 = new Date(date1.setDate(date1.getDate() - 1))

      return Util.sFormatDate(date2)
    },

  }
}
</script>